<template>
  <div class="primary--text">
    <v-content>
      <v-container>{{ message_error }}</v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  data() {
    return {
      display_name: null,
      line_error: false,
      loading: true,
      lineid: null,
      message_error: null,
      pageid: ''
    }
  },
  mounted() {
    var vm = this
    vm.$store.dispatch('loading')
    liff.init(
      (data) => {
        if (vm.$route.query.close) {
          liff.closeWindow()
        } else {
          vm.lineid = data.context.userId
          if (vm.$route.query.pageid) {
            vm.pageid = vm.$route.query.pageid
          }
          var link =
            'https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=vf6yxOil8ZhEDPxgKtZd6c&redirect_uri=' +
            window.location.protocol +
            '//' +
            window.location.hostname +
            (window.location.port ? ':' + window.location.port : '') +
            '/linenotify&scope=notify&state=' +
            vm.lineid +
            '__' +
            vm.pageid

          window.location = link
          vm.loading = false
        }
      },
      (err) => {
        vm.line_error = true
        // console.error(err)
        window.location = '/'
        // vm.message_error = err
        // vm.$store.dispatch('loading')
      }
    )
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/linenotify/Prepare.vue